import React from 'react';

import { CommonMessage } from '@frontend/lang';
import SelectInputV2, { SelectInputV2Props } from '../select/select-input-v2/select-input-v2.component';
import { countryList } from './data/countries';

interface CountryInputProps extends Omit<SelectInputV2Props<string>, 'options'> {}

export const ID = 'country-input';

export const CountryInput = (props: CountryInputProps) => {
    return (
        <SelectInputV2
            {...props}
            label={props.label || CommonMessage.FORMS.COUNTRY}
            options={countryList.map((c) => ({ label: c.label, value: c.value }))}
            value={props.value}
        />
    );
};
